export default __webpack_public_path__ + "0c4228d11d94fef08c94d207fdd3b27b.svg";